var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _g3, _g4, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse3, _ellipse4, _g6, _g7, _path25, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOinqShare = function SvgOinqShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Oinq_share_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 263.57 122.39",
    style: {
      enableBackground: "new 0 0 263.57 122.39"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Oinq_share_svg__st0{fill:#4db96e}.Oinq_share_svg__st1{fill:#242929}.Oinq_share_svg__st2{fill:#a6d7b7}.Oinq_share_svg__st3{fill:#4b5a6b}.Oinq_share_svg__st4{fill:#7e8390}.Oinq_share_svg__st5{fill:#3b9f60}.Oinq_share_svg__st6{fill:#6fc282}.Oinq_share_svg__st8{fill:#fff}.Oinq_share_svg__st9{fill:#191919}.Oinq_share_svg__st11{fill:#ad6a27}.Oinq_share_svg__st13{fill:#d08e4d}.Oinq_share_svg__st14{opacity:.23;fill:#fff;enable-background:new}.Oinq_share_svg__st16{fill:#dba876}")), /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Oinq_share",
    transform: "translate(-795.942 -874.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Oinq_friend_share",
    transform: "translate(803.379 874.469)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2552",
    transform: "rotate(-7 448.021 -719.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5032",
    className: "Oinq_share_svg__st0",
    d: "M15.72 22.67S3.74 14.22-2.54 13.08c0 0-4.31-2.95-.21-5.74-1.21-4.96 3.86-5.63 8.86-5.12s30.63 9.28 33.5 15.4-7.8 13.88-7.8 13.88-2.85 1.69-16.09-8.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5033",
    className: "Oinq_share_svg__st0",
    d: "M15.72 22.67S3.74 14.22-2.54 13.08c0 0-4.31-2.95-.21-5.74-1.21-4.96 3.86-5.63 8.86-5.12 1.26.18 2.5.45 3.72.81-2.49 4.17-3.41 8.5.57 11.17 4.77 3.26 12.19-.38 17.81-4.4 5.57 2.57 10.27 5.4 11.4 7.82 2.88 6.11-7.8 13.88-7.8 13.88s-2.85 1.69-16.09-8.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5034",
    className: "Oinq_share_svg__st1",
    d: "M10.6 3.24c-1.47-.45-2.97-.8-4.48-1.02-5-.51-10.08.16-8.86 5.12-4.09 2.81.21 5.74.21 5.74 2.55.62 5 1.59 7.29 2.87.59-4.74 2.63-9.17 5.84-12.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5035",
    className: "Oinq_share_svg__st2",
    d: "M10.07 7.2s.28-2.14 1.59-2.45 9.35 2.32 10.57 3.71c1.22 1.39-3.99 2.33-7.42 1.66s-4.64-1.66-4.74-2.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5036",
    className: "Oinq_share_svg__st3",
    d: "M-1.84 12.47s-1.56-.64-1.92-1.81.97-2.18 2.83-2.23c-1.07-.92-.5-2.78 2.06-3.54S5.86 6.42 5 9.67s-1.48 4.96-3.04 4.31-3.8-1.51-3.8-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5037",
    className: "Oinq_share_svg__st4",
    d: "M-1.01 12.54s-1.75-.43-2.23-1.4.92-1.98 2.46-.87 1.2 2.66-.23 2.27z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2554",
    transform: "translate(220.372 29.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5038",
    className: "Oinq_share_svg__st5",
    d: "M9.97 14.58S22.03 8.13 25.73 3.17c0 0 4.26-2.36 4.65 2.58 4.49 1.32 2.76 6.08.12 10.23S9.45 38.38 3.32 37.96s-7.55-13.51-7.55-13.51-.07-3.32 14.2-9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5039",
    className: "Oinq_share_svg__st5",
    d: "M9.97 14.58S22.03 8.13 25.73 3.17c0 0 4.26-2.36 4.65 2.58 4.49 1.32 2.76 6.08.12 10.23-.7 1.01-1.47 1.97-2.3 2.87-2.21-4.19-5.23-7.07-9.13-4.86-4.72 2.62-5.13 10.86-4.44 17.73-4.53 3.65-8.88 6.41-11.3 6.24-6.14-.41-7.55-13.51-7.55-13.51s-.08-3.32 14.19-9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5040",
    className: "Oinq_share_svg__st1",
    d: "M27.68 19.42c1.02-1.08 1.96-2.23 2.81-3.44 2.64-4.15 4.38-8.92-.12-10.23-.39-4.94-4.65-2.58-4.65-2.58a27.468 27.468 0 0 1-5.53 5.02 22.9 22.9 0 0 1 7.49 11.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5041",
    className: "Oinq_share_svg__st3",
    d: "M25.9 4.08a3.17 3.17 0 0 1 2.29-.81c1.08.25 1.3 1.89.51 3.55 1.21-.5 2.43.89 1.9 3.5s-3.33 3.42-5.53 1.1S21.79 7.74 23 6.68s2.9-2.6 2.9-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5042",
    className: "Oinq_share_svg__st4",
    d: "M25.47 4.78s1.12-1.33 2.11-1.28 1.16 1.77-.41 2.58-2.66-.24-1.7-1.3z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5043",
    className: "Oinq_share_svg__st5",
    d: "M232.58 98.01c-.4-.33-.77-.69-1.11-1.08-.43-.47-.76-.88-.98-1.17 3.75-.87 6.23-6.4 3.72-9.26a3.226 3.226 0 0 0-3.21-1.49c-1.74 0-3.24 1.21-3.63 2.9-.56 1.91-.44 3.96.33 5.8-2.87-.01-4.43-1.72-6.13-4.02-.89-1.12-1.64-2.34-2.25-3.63l-.28.2c-.8.58-1.76.88-2.74.86 2.17 4.05 5.65 7.66 9.91 8.48.72.19 1.46.31 2.2.34.16.01.33.01.49.01a5.866 5.866 0 0 0 2.54 2.91c2.05 1.11 4.8.06 4.81.08-.37.11-.77.14-1.15.11-.91-.09-1.8-.46-2.52-1.04zm-2.24-4.67c-1.01-.27-1.47-1.84-1.03-3.5.44-1.66 1.62-2.81 2.63-2.54 1.01.27 1.47 1.84 1.03 3.5s-1.61 2.81-2.63 2.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5044",
    className: "Oinq_share_svg__st0",
    d: "M221.08 30.63c4.54-6.16 10.91-22.85-.69-22.64-9.86.18-19.33 5.16-22.31 6.85-12-3.53-23.71-3.19-25.11-2.92-8.43-.59-16.9.5-24.91 3.2-2.3-1.37-12.33-6.94-22.79-7.13-11.9-.22-4.87 17.38-.32 23.11a49.11 49.11 0 0 0-3.64 5.29c-16.76 27.96-4.75 69.18 29.53 80.18 13.63 4.37 57.26 8.25 72.13-18.79 11.48-20.89 6.87-52.63-1.89-67.15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5045",
    className: "Oinq_share_svg__st5",
    d: "M221.08 30.63c4.12-5.61 9.78-19.93 2.01-22.31 5.89 4.49-1.01 17.53-5.09 15.83-3.45-1.21-11.44-6.8-17.91-10.41-.83.43-1.51.8-2.01 1.09h-.03c6.77 4.02 17.36 10.24 19.63 16.57 8.47 23.66 9.15 45.11-4.7 65.67-8.79 13.03-26.83 17.01-40.48 18.11a76.875 76.875 0 0 1-33.26-3.94c3.63 2.24 7.52 4.02 11.58 5.31 13.63 4.37 57.26 8.25 72.13-18.79 11.5-20.87 6.89-52.61-1.87-67.13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5046",
    className: "Oinq_share_svg__st6",
    d: "M153.95 15.71s-29.81 9.66-35.46 30.9C113.78 64.23 121 89.58 137 100.69s51.44 9.17 63.08-2.28c14.88-14.63 7.1-27.22-3.25-27.75 0 0-13.38-5.84-18.4-.03-2.51 3.62-13.62 21.48-14.56 15.68-17.9 10.96-31.1 1.14-19.38-15.86-5.05 1.55 4.87-16.7 16.55-25.98 14.53-11.54 37.52-3.4 46.48 13.1 6.77 12.45 10.04-26.98-5.02-34.71s-32.55-9.57-48.55-7.15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5047",
    className: "Oinq_share_svg__st6",
    d: "M206.05 20.35s9.66 6.53 11.08 9.08c2.27-.28 5.68-10.22 5.11-13.63s-10.22-2.54-16.19 4.55z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5048",
    className: "Oinq_share_svg__st6",
    d: "M141.94 22.86s-9.66 6.53-11.07 9.08c-2.27-.28-5.68-10.23-5.1-13.63s10.2-2.54 16.17 4.55z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5049",
    className: "Oinq_share_svg__st5",
    d: "M222.23 15.81c-.05-.26-.15-.51-.3-.73-.15-.22-.34-.4-.57-.54-.32 3.46-1.09 8.82-4.47 9.44-3.18.71-7.38-2.51-10.16-4.41-.24.25-.47.51-.69.78 0 0 9.66 6.53 11.08 9.08 2.27-.27 5.68-10.21 5.11-13.62z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5050",
    className: "Oinq_share_svg__st2",
    d: "M130.13 35.28s-9.73 10.65-11.61 23.54 4.08 7.53 8.47-5.96c4.4-13.49 9.73-20.4 11.29-23.54s-4.38 1.57-8.15 5.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oinq_share_svg__Path_5051_00000086684271889832424470000018055668612223571893_",
    gradientUnits: "userSpaceOnUse",
    x1: -136.031,
    y1: 713.861,
    x2: -136.031,
    y2: 712.861,
    gradientTransform: "matrix(4.1904 0 0 -7.687 742.533 3515.122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#242929"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5051",
    style: {
      fill: "url(#Oinq_share_svg__Path_5051_00000086684271889832424470000018055668612223571893_)"
    },
    d: "M174.59 11.79c-.54.01-1.08.07-1.61.16 0 0-.93-.13-2.57-.19v6.08c0 .18.04.36.11.52.08.16.18.31.32.43.47.43 1.08.67 1.72.67.64 0 1.25-.25 1.71-.69.11-.11.19-.24.25-.38.05-.14.08-.29.07-.44v-6.16z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5052",
    className: "Oinq_share_svg__st5",
    d: "M198.6 9.94c-.18.01-.35-.03-.51-.11-.2-.1-.38-.24-.54-.4-7.47-7.57-11.01-3.36-11.16-3.18-.07.08-.16.14-.26.16-.12.02-.24.02-.36-.02-.31-.1-.59-.29-.8-.53-.24-.25-.42-.56-.52-.89a.828.828 0 0 1 .07-.72c.05-.05 4.64-5.51 13.89 3.88.24.24.42.53.53.86.1.24.09.5-.02.73-.06.11-.18.19-.32.22z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5053",
    className: "Oinq_share_svg__st5",
    d: "M146.49 13.37a.5.5 0 0 1-.37-.1.528.528 0 0 1-.09-.55c.09-.27.24-.52.44-.73 8.38-8.46 13.53-4.95 13.58-4.91.07.05.13.13.15.22.03.11.03.22 0 .32-.03.13-.08.26-.15.38a2 2 0 0 1-.28.37 2.11 2.11 0 0 1-.75.52c-.11.04-.24.07-.36.07-.1 0-.19-.03-.27-.08-.17-.11-4.18-2.78-10.91 4-.15.14-.31.27-.5.36-.15.07-.31.12-.49.13z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_share_svg__Ellipse_189",
    className: "Oinq_share_svg__st8",
    cx: 184.63,
    cy: 28.79,
    rx: 9.92,
    ry: 12.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_share_svg__Ellipse_190",
    className: "Oinq_share_svg__st8",
    cx: 160.53,
    cy: 29.08,
    rx: 10,
    ry: 13.85
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2555",
    transform: "translate(180.878 25.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5054",
    className: "Oinq_share_svg__st9",
    d: "M-.1 10.88a4.131 4.131 0 0 0 0-8.26 4.131 4.131 0 0 0 0 8.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5055",
    className: "Oinq_share_svg__st1",
    d: "M2.93 3.94c.4 1.67.48 4.78-3.37 6.92.83.07 1.66-.11 2.39-.52.72-.42 1.3-1.04 1.67-1.79.36-.75.49-1.59.37-2.41-.12-.82-.49-1.59-1.06-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5056",
    className: "Oinq_share_svg__st8",
    d: "M-.61 5.95c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2556",
    transform: "translate(163.459 24.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5057",
    className: "Oinq_share_svg__st9",
    d: "M.11 11.29c2.4 0 4.34-1.94 4.34-4.34S2.51 2.61.11 2.61s-4.34 1.94-4.34 4.34 1.94 4.34 4.34 4.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5058",
    className: "Oinq_share_svg__st1",
    d: "M3.29 4c.42 1.75.51 5.02-3.54 7.27.87.07 1.74-.12 2.5-.55.76-.43 1.37-1.08 1.75-1.87.39-.79.52-1.67.4-2.53-.13-.87-.51-1.68-1.11-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5059",
    className: "Oinq_share_svg__st8",
    d: "M-.43 6.12a.939.939 0 1 0 0-1.88.939.939 0 1 0 0 1.88z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2557",
    transform: "translate(150.335 35.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5060",
    className: "Oinq_share_svg__st5",
    d: "M15.84 3.53S3.78 5.12-2.18 16.03c-4.23 7.6-2.39 19.55 10.08 19.13s19.4.47 26.06 2.97 16.79 1.97 19.22-3.72 3.1-15-4-22S30.8.49 15.84 3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5061",
    className: "Oinq_share_svg__st0",
    d: "M-1.11 20.88s-2.19 9.89 7.26 11.47c9.46 1.58 15.28-.96 30.47 3.47S53.79 30.05 51.9 21.9 39.74 5.83 27.52 4.6 2.66 8.01-1.11 20.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5062",
    className: "Oinq_share_svg__st5",
    d: "M13.17 21.03a3.857 3.857 0 0 1-4.18 3.47 3.86 3.86 0 0 1-2.82-4.64c.2-2.11 2.07-3.66 4.18-3.48 2.05.51 3.31 2.58 2.82 4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5063",
    className: "Oinq_share_svg__st1",
    d: "M14.18 22.34A3.872 3.872 0 0 1 10 25.82c-2.06-.51-3.31-2.59-2.82-4.65a3.872 3.872 0 0 1 4.18-3.48c2.05.51 3.31 2.59 2.82 4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5064",
    className: "Oinq_share_svg__st5",
    d: "M44.13 24.81a3.879 3.879 0 0 1-4.18 3.48 3.878 3.878 0 0 1-2.82-4.64c.2-2.11 2.07-3.66 4.18-3.48 2.05.5 3.31 2.58 2.82 4.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5065",
    className: "Oinq_share_svg__st1",
    d: "M45.15 26.12a3.872 3.872 0 0 1-4.18 3.48 3.855 3.855 0 0 1-2.82-4.65 3.872 3.872 0 0 1 4.18-3.48c2.05.51 3.31 2.59 2.82 4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5066",
    className: "Oinq_share_svg__st2",
    d: "M28.16 5.88s-9-1.5-11.9 1.59c-.54 1.4 3.82 3.92 9.05 3s6.43-4.58 2.85-4.59z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5067",
    d: "m146 86.14 49.55-7.15s15.67 16.15-1.01 23.34-43.9-6.19-48.54-16.19z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5068",
    className: "Oinq_share_svg__st8",
    d: "M146 86.14s30.84 4.38 44.45 1.86l.66-1.38.82 1.06c1.3-.27 2.53-.79 3.62-1.54v-7.15L146 86.14z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5069",
    d: "M164 99.83s14.74-9.7 34.52-.4c0 0-11.46 10.84-34.52.4z",
    style: {
      fill: "#e41f5c"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5070",
    className: "Oinq_share_svg__st5",
    d: "M171.01 11.23s-.63 7.11.3 8.03-2.34-.21-2.34-.21l-1.54-5.5.83-2.7 2.75.38z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5071",
    className: "Oinq_share_svg__st5",
    d: "M175.4 11.55s-.81 6.79-1.73 7.7 2.34-.21 2.34-.21l1.54-5.5-.83-2.7-1.32.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2565",
    transform: "translate(0 19.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2558",
    transform: "translate(0 28.787)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5072",
    className: "Oinq_share_svg__st11",
    d: "M5.15 27c.34-.68.62-1.39.83-2.11.29-.89.49-1.64.61-2.16-5.55 1.1-12.19-4.81-10.56-10.14.75-2.46 1.11-2.86 3.39-3.93a5.475 5.475 0 0 1 6.6 1.69 12.73 12.73 0 0 1 3.05 7.96c3.83-1.74 4.9-4.98 5.78-9.07.52-2.03.79-4.12.81-6.22l.49.1c1.41.29 2.88.11 4.19-.5-.46 6.72-2.93 13.66-8.15 17.32-.85.69-1.77 1.29-2.74 1.79-.21.11-.43.21-.65.3.08 1.94-.5 3.85-1.64 5.42-2.07 2.72-6.39 2.98-6.39 3 .56-.08 1.11-.27 1.61-.55A6.917 6.917 0 0 0 5.15 27zm.17-7.59c1.19-.97.86-3.34-.74-5.3S.72 11.33-.47 12.3s-.86 3.34.74 5.31 3.86 2.76 5.05 1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5073",
    d: "m12.99 15.11-.05-.23c.94-1.77 1.59-3.67 1.93-5.65.35-1.46.6-2.95.76-4.45l4.45.29c-.84 5.92-3.31 11.68-7.89 14.88-.85.69-1.77 1.29-2.74 1.79-.21.11-.42.2-.63.3-1.31.24-2.19.35-2.19.35 2.64-1.1 6.36-7.28 6.36-7.28z",
    style: {
      opacity: 0.29,
      fill: "#191919",
      enableBackground: "new"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5074",
    className: "Oinq_share_svg__st13",
    d: "M15.27 21.18c-3.75-5.05-9.02-18.74.57-18.57 8.16.15 15.99 4.23 18.45 5.62a62.82 62.82 0 0 1 20.77-2.39c6.98-.48 13.98.41 20.61 2.62 1.9-1.13 10.2-5.69 18.85-5.85 9.84-.18 4.02 14.25.27 18.95 1.1 1.38 2.1 2.83 3.01 4.34 13.86 22.94 3.93 56.75-24.43 65.77C62.1 95.25 26 98.43 13.7 76.26 4.21 59.13 8.02 33.1 15.27 21.18z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5075",
    className: "Oinq_share_svg__st11",
    d: "M15.39 20.94c-3.47-4.53-8.23-16.1-1.69-18.02-4.96 3.62.85 14.16 4.28 12.79 2.91-.98 9.62-5.49 15.07-8.41.7.34 1.27.65 1.69.88h.03c-5.69 3.25-14.61 8.27-16.52 13.39-7.13 19.11-7.7 36.44 3.96 53.05 7.39 10.52 22.58 13.74 34.06 14.63 9.45.93 18.98-.16 27.98-3.18a45.092 45.092 0 0 1-9.75 4.29c-11.47 3.53-48.18 6.66-60.69-15.18-9.66-16.88-5.79-42.51 1.58-54.24z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5076",
    className: "Oinq_share_svg__st14",
    d: "M66.96 9.61s27.52 7.73 32.74 24.73c4.34 14.1-2.32 34.38-17.09 43.27s-47.48 7.34-58.23-1.82c-13.73-11.71-6.55-21.78 3-22.2 0 0 12.35-4.67 16.98-.03 2.32 2.9 12.75 3.48 13.62-1.16 2.32-2.7 6.88-.79 17.38 2.03 4.66 1.24 13.54-9.48 2.76-16.91-13.42-9.23-52.34-7.61-60.61 5.59-6.25 9.96-9.27-21.59 4.63-27.77s30.05-7.66 44.82-5.73z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5077",
    className: "Oinq_share_svg__st14",
    d: "M27.45 14.02s-8.91 6.03-10.23 8.39c-2.09-.26-5.24-9.44-4.72-12.58s9.44-2.35 14.95 4.19z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5078",
    className: "Oinq_share_svg__st11",
    d: "M12.51 9.83c.04-.24.14-.47.28-.67.14-.2.32-.37.53-.5.3 3.19 1 8.15 4.12 8.71 2.94.65 6.81-2.32 9.37-4.07.22.24.44.47.63.72 0 0-8.91 6.03-10.23 8.39-2.08-.26-5.22-9.43-4.7-12.58z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5079",
    className: "Oinq_share_svg__st11",
    d: "M65.19 21.8c.16.03.33.01.48-.06.19-.07.37-.18.53-.32 7.54-6.29 10.42-2.11 10.54-1.93.05.08.13.14.22.17.11.03.22.04.33.01.29-.07.56-.21.78-.42.24-.21.43-.47.55-.77.1-.21.1-.46 0-.67-.04-.05-3.77-5.47-13.1 2.32-.24.2-.43.45-.56.74-.11.21-.13.45-.04.68.05.12.15.21.27.25z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5080",
    className: "Oinq_share_svg__st11",
    d: "M90.01 31.78c.07.06.17.1.26.09.14-.04.26-.15.29-.29.07-.2.08-.41.05-.62-1.44-8.66-6.04-8.74-6.08-8.74-.07 0-.13.02-.18.07-.06.05-.11.12-.14.2-.04.09-.06.19-.07.29-.01.11-.01.23.01.34.02.12.04.23.08.34.04.1.09.2.15.29.05.08.11.14.19.19.06.04.13.07.2.07.15 0 3.7.11 4.86 7.05.03.15.08.29.15.43.06.11.14.21.23.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oinq_share_svg__Path_5081_00000026858019640280471880000013691194756057873839_",
    gradientUnits: "userSpaceOnUse",
    x1: -169.989,
    y1: 411.985,
    x2: -169.989,
    y2: 410.985,
    gradientTransform: "matrix(31.6699 0 0 -4.9514 5441.05 2046.036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#242929"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5081",
    style: {
      fill: "url(#Oinq_share_svg__Path_5081_00000026858019640280471880000013691194756057873839_)"
    },
    d: "M73.35 11.08h-4.88S48.78 5.45 41.68 6.65c0 0 12.42-2.76 31.67 4.43z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5082",
    className: "Oinq_share_svg__st11",
    d: "M69.69 11.04S55.02 7.07 47.6 6.43s-1.89-.05-1.89-.05 18.14 3.28 20.46 5.09l3.52-.43z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5083",
    className: "Oinq_share_svg__st11",
    d: "M75.8 10.77S61.13 6.99 53.71 6.38s-1.89-.05-1.89-.05 18.14 3.12 20.46 4.85l3.52-.41z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_share_svg__Ellipse_191",
    className: "Oinq_share_svg__st8",
    cx: 84.25,
    cy: 33.73,
    rx: 3.77,
    ry: 6.33
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_share_svg__Ellipse_192",
    className: "Oinq_share_svg__st8",
    cx: 75.15,
    cy: 31.88,
    rx: 4.47,
    ry: 7.51
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2559",
    transform: "translate(87.134 28.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5084",
    className: "Oinq_share_svg__st9",
    d: "M-1.99 9.35c-1.24 0-2.24-1.51-2.24-3.37s1-3.37 2.24-3.37S.25 4.12.25 5.98s-1 3.37-2.24 3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5085",
    className: "Oinq_share_svg__st1",
    d: "M-3.39 5.61a3.41 3.41 0 0 0 1.05 3.23.953.953 0 0 1-.74-.24 1.86 1.86 0 0 1-.52-.84c-.11-.36-.15-.75-.12-1.12.03-.37.15-.72.33-1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5086",
    className: "Oinq_share_svg__st8",
    d: "M-2.16 6.25c-.27 0-.49-.33-.49-.73s.22-.73.49-.73.49.33.49.73-.22.73-.49.73z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2560",
    transform: "translate(77.421 26.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5087",
    className: "Oinq_share_svg__st9",
    d: "M-1.57 10.61c-1.47 0-2.66-1.79-2.66-4s1.19-4 2.66-4 2.66 1.79 2.66 4-1.19 4-2.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5088",
    className: "Oinq_share_svg__st1",
    d: "M-3.23 6.16c-.3 1.41.17 2.86 1.24 3.83-.32.03-.64-.07-.88-.29-.29-.27-.5-.61-.61-.99-.14-.43-.18-.89-.14-1.33.04-.43.17-.84.39-1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5089",
    className: "Oinq_share_svg__st8",
    d: "M-1.77 6.92c-.32 0-.58-.39-.58-.87s.26-.87.58-.87.58.39.58.87-.26.87-.58.87z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5105",
    d: "M60.13 59.24s-20.5 16.78-25.52-9.37 25.52 9.37 25.52 9.37z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_share_svg__Group_2561",
    transform: "translate(57.12 35.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5090",
    className: "Oinq_share_svg__st11",
    d: "M38.57 7.24c.61.26 1.2.57 1.78.9 1.47.84 2.86 1.82 4.16 2.92 1.82 1.54 3.42 3.31 4.77 5.26 1.66 2.42 2.9 5.1 3.66 7.94.61 2.23.8 4.55.58 6.85a15.33 15.33 0 0 1-1.94 6.32 9.495 9.495 0 0 1-4.56 4.11c-2.35.88-4.92.94-7.31.19-2.92-.79-5.53-1.42-7.93-1.9s-4.56-.83-6.58-1.04c-1.9-.2-3.8-.28-5.71-.23-1.77.05-3.54.22-5.28.51-1.85.29-3.73.33-5.59.12-1.92-.2-3.8-.65-5.59-1.35-1.68-.63-3.21-1.58-4.52-2.8a7.873 7.873 0 0 1-2.35-4.23c-.32-1.8-.44-3.63-.36-5.46.08-2.04.43-4.07 1.02-6.02.63-2.09 1.58-4.06 2.83-5.85 1.37-1.94 3.08-3.62 5.06-4.94C6.86 7.08 9.2 5.89 11.65 5c2.6-.94 5.32-1.53 8.09-1.75 3.02-.23 6.07-.04 9.04.57 3.39.71 6.69 1.86 9.79 3.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5091",
    className: "Oinq_share_svg__st13",
    d: "M50.99 28.99c-.01.55-.05 1.11-.13 1.66-.16 1.24-.49 2.45-.97 3.61a8.478 8.478 0 0 1-2.68 3.53 7.955 7.955 0 0 1-5.29 1.41c-2.14-.12-4.26-.4-6.35-.85-2.01-.41-3.99-.9-6.16-1.35-2.42-.51-4.88-.85-7.35-1.04-3.32-.22-6.65-.19-9.96.09-3.93.31-6.88-.16-9.03-1.16a8.104 8.104 0 0 1-4.26-4.39c-.73-1.97-.94-4.09-.62-6.17.3-2.23.92-4.4 1.84-6.46.97-2.13 2.36-4.03 4.08-5.6a24.66 24.66 0 0 1 6.4-4.24c2.53-1.17 5.21-1.97 7.97-2.39 2.91-.45 5.86-.47 8.78-.07a33.1 33.1 0 0 1 8.61 2.39c2.69 1.16 5.18 2.74 7.37 4.69 2.2 1.97 4.01 4.35 5.31 7a24.68 24.68 0 0 1 2.44 9.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5092",
    className: "Oinq_share_svg__st16",
    d: "M37.58 25.93c-.02.58.05 1.15.21 1.71.14.51.37.99.68 1.42.28.4.64.73 1.05.99.4.24.85.38 1.32.41.46.02.92-.07 1.34-.27.43-.21.81-.51 1.12-.87.34-.4.6-.85.78-1.34.2-.54.31-1.1.34-1.67.02-.57-.04-1.15-.2-1.7-.14-.51-.37-.99-.67-1.42-.28-.4-.63-.74-1.04-1a2.776 2.776 0 0 0-2.66-.16c-.43.21-.81.5-1.12.87-.34.4-.61.85-.79 1.34-.22.54-.34 1.11-.36 1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5093",
    className: "Oinq_share_svg__st1",
    d: "M36.36 27.06c-.02.58.04 1.15.2 1.71.15.51.38.99.69 1.42.28.4.64.74 1.05.99.4.24.85.39 1.32.41.46.02.92-.07 1.34-.27.43-.21.81-.51 1.12-.87.34-.4.6-.85.79-1.34.2-.54.31-1.1.33-1.68.02-.57-.04-1.15-.2-1.7-.14-.51-.37-.99-.67-1.42-.28-.4-.64-.74-1.05-1-.4-.25-.85-.39-1.31-.42-.46-.03-.93.06-1.35.26-.43.21-.81.51-1.12.87-.34.4-.61.85-.79 1.35a5.15 5.15 0 0 0-.35 1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5094",
    className: "Oinq_share_svg__st16",
    d: "M7.05 22.75c-.02.59.05 1.18.22 1.74.15.52.39 1.01.71 1.45.29.41.66.75 1.09 1.01.41.25.88.39 1.35.42.48.02.95-.07 1.38-.27.44-.21.84-.51 1.16-.89.35-.4.63-.86.81-1.36.21-.54.33-1.12.35-1.7.02-.59-.05-1.17-.21-1.73-.15-.52-.39-1.01-.7-1.45a3.59 3.59 0 0 0-1.08-1.01c-.41-.25-.88-.4-1.36-.43-.48-.03-.96.06-1.39.27-.45.21-.84.51-1.16.89-.35.4-.63.86-.82 1.36-.2.54-.32 1.12-.35 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_share_svg__Path_5095",
    className: "Oinq_share_svg__st1",
    d: "M5.79 23.9c-.02.58.05 1.17.21 1.74.15.52.39 1.01.7 1.45.3.4.67.75 1.1 1.01.41.25.88.39 1.36.42.48.02.96-.07 1.39-.27.44-.21.84-.51 1.16-.89.35-.4.62-.87.81-1.36.21-.54.32-1.12.35-1.7.03-.59-.04-1.17-.21-1.73-.15-.52-.39-1.01-.7-1.45-.29-.41-.66-.75-1.08-1.02-.41-.25-.88-.4-1.36-.43-.48-.03-.96.06-1.39.27-.45.21-.84.51-1.17.88-.35.4-.63.87-.82 1.36-.21.55-.33 1.13-.35 1.72z"
  })))))));
};
export default SvgOinqShare;